import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Belgische tijd met automatische winter/zomeruur (DST) correctie.
// Werkt ongeacht de tijdzone van browser of server.
export function brusselsDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('nl-BE', { timeZone: 'Europe/Brussels' });
}

export function brusselsDate(iso, opts) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('nl-BE', { timeZone: 'Europe/Brussels', ...opts });
}

export function brusselsTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleTimeString('nl-BE', { timeZone: 'Europe/Brussels', hour: '2-digit', minute: '2-digit' });
}

export const isIframe = window.self !== window.top;